import type { PermissionId } from "@/constants/permissions.constants";
import type { RootState } from "@/store";

const EMPTY_USER_ROLES: string[] = [];

export const baseSelector = (state: RootState) => state.user;

export const userPermissionSelector =
  (page: PermissionId) =>
  (state: RootState): boolean =>
    baseSelector(state).userAppPermissions[page]?.hasControl ?? false;

export const userAppRolesSelector =
  (page: PermissionId) =>
  (state: RootState): string[] =>
    baseSelector(state).userAppPermissions[page]?.roles ?? EMPTY_USER_ROLES;

export const userRolesSelector = (state: RootState) =>
  baseSelector(state).roles;
